import React from "react";
import Badge from "../../../components/common/Badge";
import {
  notificationStatusVariants,
  notificationStatusMessages,
} from "../constants/notificationConstants";
import {
  ClockIcon,
  RefreshIcon,
  CheckCircleIcon,
  XCircleIcon,
  BanIcon,
} from "@heroicons/react/outline";

const JobStatusChip = ({ status, size = "md", showIcon = true }) => {
  const getIcon = () => {
    switch (status?.toLowerCase()) {
      case "queued":
        return <ClockIcon className="w-3 h-3" />;
      case "sending":
        return <RefreshIcon className="w-3 h-3 animate-spin" />;
      case "sent":
        return <CheckCircleIcon className="w-3 h-3" />;
      case "failed":
        return <XCircleIcon className="w-3 h-3" />;
      case "cancelled":
        return <BanIcon className="w-3 h-3" />;
      default:
        return null;
    }
  };

  const statusLower = status?.toLowerCase();
  
  return (
    <Badge
      variant={notificationStatusVariants[statusLower] || "default"}
      size={size}
      className="inline-flex items-center gap-1"
    >
      {showIcon && getIcon()}
      <span>{notificationStatusMessages[statusLower] || status}</span>
    </Badge>
  );
};

export default JobStatusChip;
